import React, { forwardRef } from 'react';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import * as ST from './styled';
var colorScheme = {
    LabelsText_1: 'LabelsBg_1',
    LabelsText_2: 'LabelsBg_2',
    LabelsText_3: 'LabelsBg_3',
    LabelsText_4: 'LabelsBg_4',
    LabelsText_5: 'LabelsBg_5',
    LabelsText_6: 'LabelsBg_6',
};
var Label = forwardRef(function (_a, ref) {
    var textColor = _a.textColor, bgColor = _a.bgColor, className = _a.className, outlined = _a.outlined, children = _a.children, type = _a.type, onClick = _a.onClick;
    return (<ST.Label ref={ref} data-test={'label'} className={className} textColor={type ? COLORS[type] : textColor} bgColor={type ? COLORS[colorScheme[type]] : bgColor} type={type} outlined={outlined} onClick={onClick}>
            <ST.LabelContent type={type} data-test={'label-content'}>
                {children}
            </ST.LabelContent>
        </ST.Label>);
});
Label.displayName = 'Label';
export { Label };
